<template>
    <div>
        <div class="ptop-10 pright-10 pleft-10" v-if="cartNoticeMsg">
            <div class="alert alert-warning">
                <i class="fas fa-info-circle"></i> {{ cartNoticeMsg }}
            </div>
        </div>
        <div class="ptop-10 pright-10 pleft-10" v-if="cart && cart.error">
            <div class="alert alert-warning">
                {{ $t(cart.error) }}
            </div>
        </div>
        <div v-else-if="loadingPrice" class="cart-loader-container loader-container text-center">
          <div class="icon">
            <div class="sk-wave">
              <div class="sk-rect sk-rect1"></div>
              <div class="sk-rect sk-rect2"></div>
              <div class="sk-rect sk-rect3"></div>
              <div class="sk-rect sk-rect4"></div>
              <div class="sk-rect sk-rect5"></div>
            </div>
          </div>
          <div class="title">{{ $t(loadingPrice) }}</div>
        </div>
        <div class="empty-indicator" v-else-if="!hasItems">
            <i class="fa fa-shopping-cart"></i> {{ $t('ProjectDetails.emptyCart') }}
        </div>
        <cart
                v-else
                class="card-table"
                :items="cart.items"
                :netamount="cart.netamount"
                :tax="cart.tax"
                :total="cart.total"
                :editable="true"
                :show-prices="showPrices"
                v-on:itemclick="handleCartItemClick"
                v-on:change="handleCartItemUpdate"
        ></cart>
        <div class="pad-20" v-if="!hasOrder">
            <div class="col-xs-12 col-sm-7 col-md-6 col-lg-5 float-left float-left" v-if="!disableAddress">
                <addresscard
                        :contact-id="deliveryAddress.ID"
                        :type="deliveryAddress.type"
                        :title="deliveryAddress.title"
                        :firstname="deliveryAddress.firstname"
                        :lastname="deliveryAddress.lastname"
                        :address="deliveryAddress.address"
                        :postalcode="deliveryAddress.postalcode"
                        :city="deliveryAddress.city"
                        :country="deliveryAddress.country"
                        :is-shipping="1"
                        v-on:change="changeAddress"
                        :changable="!$root.isPrintMode"
                ></addresscard>
            </div>
            <div id="btnOrderContainer">
                <div class="form form-horizontal">
                    <field
                            label-class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            field-class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            name="shipping"
                            :label="$t('ProjectDetails.shippingType')"
                            type="select"
                            :value="formValues.shipping"
                            v-if="!hasOrder && requireShipping"
                            :options="deliveryOptionsArray"
                            :required="true"
                            v-on:input="handleFormInput"
                    ></field>
                </div>
                <button
                        v-if="hasItems"
                        type="button"
                        class="btn btn-lg btn-primary"
                        v-on:click="orderProject"
                        :disabled="!readyToOrder || (requireShipping && !hasShippingAddress)"
                ><i class="fa fa-truck"></i> {{ $t('ProjectDetails.orderProject') }}</button>
            </div>
            <div class="clear" :style="clearStyle">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    order: Object,
    cart: Object,
    showPrices: Boolean,
    disableAddress: Boolean,
    deliveryAddress: Object,
    formValues: Object,
    itemNums: Object,
    deliveryOptions: {},
    requireShipping: Boolean,
    readyToOrder: Boolean,
    loadingPrice: {},
    cartNotice: Object,
  },
  watch: {
    readyToOrder(v) {
      this.readyToOrder = v;
      this.$forceUpdate();
    }
  },
  computed: {
    hasShippingAddress() {
      return typeof this.formValues.shipping == 'string' && this.formValues.shipping != '';
    },
    hasOrder() {
      return typeof this.order.ID !== 'undefined';
    },
    cartNoticeMsg() {
      return (typeof this.cartNotice != 'undefined') ? this.$root.getLabelText(this.cartNotice) : null;
    },
    hasItems() {
      return typeof this.cart.items == 'object' && this.cart.items != null && this.cart.items.length > 0;
    },
    deliveryOptionsArray() {
      return Array.isArray(this.deliveryOptions)
        ? this.deliveryOptions
        : Object.values(this.deliveryOptions);
    },
    clearStyle() {
      const res = this.$root.isEmbeddedMode && !this.hasOrder && this.requireShipping && this.deliveryOptionsArray.length > 4
        ? `margin-bottom: ${(this.deliveryOptionsArray.length - 4) * 35}px;` : '';
      return res;
    }
  },
  methods: {
    handleCartItemClick(item) {
      this.$emit('item-click', item);
    },
    handleCartItemUpdate(item) {
      this.$emit('change', item);
    },
    changeAddress() {
      this.$emit('change-address');
    },
    handleFormInput(value, field, itemnum) {
      this.formValues[field.name] = value;
      this.itemNums[field.name] = itemnum;
      this.$emit('input', value, field, itemnum);

      this.$forceUpdate();
    },
    orderProject() {
      this.$emit('order');
    },
    getItemNums() {
      const keys = ['shipping'];
      const items = {};
      Object.keys(this.itemNums)
        .filter(x => keys.indexOf(x) >= 0)
        .map(x => this.itemNums[x])
        .filter(x => x)
        .forEach(itemnum => {
          items[itemnum] = (items[itemnum] || 0) + 1;
        });

      return [{
        section: null,
        items,
      }];
    },
  }
}
</script>
